import { render, staticRenderFns } from "./BaseChart.vue?vue&type=template&id=87eb287a&"
import script from "./BaseChart.vue?vue&type=script&lang=js&"
export * from "./BaseChart.vue?vue&type=script&lang=js&"
import style0 from "./BaseChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87eb287a')) {
      api.createRecord('87eb287a', component.options)
    } else {
      api.reload('87eb287a', component.options)
    }
    module.hot.accept("./BaseChart.vue?vue&type=template&id=87eb287a&", function () {
      api.rerender('87eb287a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/BaseChart.vue"
export default component.exports